import { Breakpoints, CTA, styled, Text} from "@volkswagen-onehub/components-core";
import { ResultsView } from "../utils/results-view-context";

export type CustomDetailsCTAProps = {
    paddingX?: string
}

export const CustomDetailsCTA = styled(CTA) <CustomDetailsCTAProps>`

`;

export type ResultsProps = {
    view: ResultsView;
}

export const ResultsViewContainer = styled.div<ResultsProps>`
  display: grid;
  row-gap: ${props => props.theme.size.dynamic0100};
  column-gap: ${props => props.theme.size.dynamic0100};
  ${props =>
        props.view === ResultsView.GRID
            ? `
      --min-width: 250px;
      grid-template-columns: repeat(auto-fill, minmax(var(--min-width), 1fr));
      @media (min-width: ${Breakpoints.b560}px) {
        --min-width: 360px;
      }
    `
            : `grid-template-columns: auto;`
    }
`;

export const Label = styled(Text)`
  color: #001E50;
  padding: 0 18px;
`;
